import { Card, Flex, Text, Title } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import BadgeStatus from '../../components/elements/BadgeStatus';
import GridCell from '../../components/elements/GridCell';
import FormBlockedNik from '../../components/forms/FormBlockedNik';
import IcUser from '../../components/icons/IcUser';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionUpdateNikStatus, fetchSearchNik } from './action';
import { fetchReasons } from '../SettingReasonBlockId/actions';
import { AppContext } from '../../contexts';
import CustomerTypeList from '../../components/fragments/CustomerTypeList/index';

export default function NikBlocked() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const { id } = useParams();
  const { dataNikManagement, updateNikStatus } = useSelector((state) => state.nikManagement);
  const { dataReason, dataReasonDetail } = useSelector((s) => s.settingReasonBlockId);
  const searchResult = dataNikManagement?.data || {};
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    dispatch(fetchSearchNik(id, true));
  }, [id]);

  useEffect(() => {
    dispatch(fetchReasons('dataReason'));
    dispatch(fetchReasons('dataReasonDetail'));
    setBreadcrumbs([
      { name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      'Blokir NIK Pelanggan'
    ]);
  }, []);

  useEffect(() => {
    if(!updateNikStatus.isLoading && isBlocked) {
      navigate('/customer-setting');
    }
  }, [updateNikStatus, isBlocked]);

  const handleSubmit = (data) => {
    const bodyReq = {
      'actionType': 'block',
      'nationalityId': id,
      'reasonId': data?.reasonId || '',
      'reasonDetailId': data.reasonDetailId || '',
      // 'isRequestUnblock': data.requestUnblock === '1',
      'supportDocument': data.supportDocument || null,
    };
    const formData = new FormData();
    Object.keys(bodyReq).forEach(key => {
      formData.append(key, bodyReq[key]);
    });
    dispatch(actionUpdateNikStatus(formData));
    // dispatch(actionUpdateNikStatus(bodyReq));
    setIsBlocked(true);
  };


  const renderResultSearch = () => {
    return(
      <Card radius={'lg'} withBorder>
        <Flex align="center" gap="sm">
          <IcUser/>
          <Text size="lg" weight={500}>{searchResult.name}</Text>
          <BadgeStatus label={searchResult.isBlocked ? 'NIK Diblokir' : 'Aktif'} />
        </Flex>
        <br/>
        <GridCell data={searchResult.nationalityId} label="NIK" left={3} />
        <GridCell data={<CustomerTypeList customerTypes={searchResult?.customerTypes}/>} label="Jenis Pelanggan" left={3} />
      </Card>
    );
  };
  return (
    <div>
      <Card px={24} radius={'12px'} withBorder>
        <Card.Section p="md">
          <Title fz={30} order={4}>Blokir NIK Pelanggan</Title>
          <Text c={'#52575C'} fw={400} mb="md" size="md">
          Pelanggan yang diblokir tidak dapat melakukan transaksi
          dan pendaftaran jenis pengguna lain.
          </Text>
        </Card.Section>
        {renderResultSearch()}
        <br/>
        <FormBlockedNik
          dataReason={dataReason}
          dataReasonDetail={dataReasonDetail}
          handleSubmit={handleSubmit}
          isLoading={updateNikStatus.isLoading} navigate={navigate}/>
      </Card>
    </div>
  );
}
